export function DashboardEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center p-4 text-center">
      <h2 className="text-xl font-medium">Ainda não há insights</h2>
      <p className="text-sm text-darkgray-400 font-medium">
        Continue usando a plataforma e logo verá novos insights aqui.
      </p>
    </div>
  );
}
